import type { ClientPatch } from '../types/app'

// Whether a client is asked for a review (spec 2026-10-08, amended
// 2026-10-09): until she or the client chooses, they are asked after
// appointments booked online, because the booking form said so, and after
// imported ones once she has switched on emails for those (owner, 2026-11-02).
export type ReviewAsking = 'online' | 'always' | 'never'

export function reviewAsking(c: { review_emails: boolean; review_emails_auto?: boolean }): ReviewAsking {
  if (c.review_emails) return 'always'
  return c.review_emails_auto ? 'online' : 'never'
}

export function reviewAskingPatch(choice: Exclude<ReviewAsking, 'online'>): ClientPatch {
  return { review_emails: choice === 'always' }
}

// The online default can't be chosen back once someone has decided.
export function REVIEW_ASKING(current: ReviewAsking, importedEmails = false): { value: ReviewAsking; label: string }[] {
  const all: { value: ReviewAsking; label: string }[] = [
    { value: 'online', label: importedEmails ? 'After online and imported bookings' : 'After online bookings' },
    { value: 'always', label: 'After every appointment' },
    { value: 'never', label: 'Never' },
  ]
  return current === 'online' ? all : all.filter((o) => o.value !== 'online')
}
